module.exports = __webpack_public_path__ + "img/TimePressureDetails-min.01fb6f80.png";